// extracted by mini-css-extract-plugin
export default {"closeIcon":"Popup_closeIcon__1Vtm3","header":"Popup_header__wlZVP","btns":"Popup_btns__BU26E","activebtn":"Popup_activebtn__Dx1uW","cancelbtn":"Popup_cancelbtn__inHOD"};